import React from 'react';
import { Link, Link as RouterLink } from 'react-router-dom';
import { Box, Button, Hidden } from '@mui/material';

import { Logo } from './logo';
import { TopLevelMenuUrl } from '@matematykagryzie/consts';

export function Header() {
  const goToPurchase = () =>
    document.getElementById('purchase').scrollIntoView();
  return (
    <header>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Logo />

        <Box display="flex">
          <Hidden smDown>
            <Box mx={2}>
              <Button
                style={{
                  minWidth: 0,
                }}
                variant="contained"
                onClick={goToPurchase}
              >
                Kup kurs
              </Button>
            </Box>
          </Hidden>

          <Button
            style={{
              minWidth: 0,
            }}
            href={TopLevelMenuUrl.App}
          >
            Zaloguj się
          </Button>
        </Box>
      </Box>
    </header>
  );
}

export default Header;
